import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import moment from 'moment';
import { REQUEST_URL } from '../config/urls';

class Cronograma extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dadosContrato: null,
      procedimentos: [],
      refeito: null,
      erro: null,
      jaCarregou: false,
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    if (!this.props.carregando && this.props.contrato && this.props.contrato.numero) {
      this._buscar(this.props.contrato.numero);
    }
  }

  componentDidUpdate(prevProps) {
    const numero = this.props.contrato && this.props.contrato.numero;
    if (prevProps.carregando && !this.props.carregando && numero && !this.state.jaCarregou) {
      this._buscar(numero);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  _buscar(numero) {
    if (!this._isMounted || this.state.loading) return;
    this.setState({ loading: true, jaCarregou: true });
    axios.get(REQUEST_URL + '/dashboard/contrato/timeline', {
      params: { codigo: numero },
    }).then((response) => {
      if (!this._isMounted) return;
      this.setState({
        dadosContrato: response.data.contrato,
        procedimentos: response.data.procedimentos || [],
        refeito: response.data.refeito || null,
        loading: false,
      });
    }).catch((err) => {
      if (!this._isMounted) return;
      console.error('[Cronograma]', err.message);
      this.setState({ loading: false, erro: 'Não foi possível carregar o cronograma.' });
    });
  }

  _statusInfo(proc) {
    const s = (proc.Status || '').toLowerCase();
    if (proc.atrasado)                              return { cor: '#dc2626', bg: '#fee2e2', label: 'Atrasado',    icon: '⚠' };
    if (s === 'concluido')                          return { cor: '#16a34a', bg: '#dcfce7', label: 'Concluído',   icon: '✓' };
    if (s === 'execução' || s === 'execucao')       return { cor: '#2563eb', bg: '#dbeafe', label: 'Em execução', icon: '▶' };
    return                                                 { cor: '#94a3b8', bg: '#f1f5f9', label: 'Aguardando',  icon: '○' };
  }

  render() {
    const { loading, dadosContrato, procedimentos, erro } = this.state;

    const renderCorpo = () => {
      if (loading || this.props.carregando) {
        return (
          <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>
            <p>Carregando cronograma...</p>
          </div>
        );
      }
      if (erro) {
        return <div style={{ padding: 40, textAlign: 'center', color: '#dc2626' }}><p>{erro}</p></div>;
      }
      if (!dadosContrato) {
        return <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}><p>Nenhum cronograma encontrado.</p></div>;
      }

      return (
        <div>
          {/* Info bar */}
          <div style={{
            display: 'flex', flexWrap: 'wrap', gap: 20,
            padding: '12px 20px', background: '#f8fafc',
            borderBottom: '1px solid #e2e8f0', fontSize: 13, color: '#475569',
          }}>
            <span><b>Responsável:</b> {dadosContrato.RegistradoPor || '-'}</span>
            <span><b>Entrega:</b> {dadosContrato.dt_entrega ? moment(dadosContrato.dt_entrega).format('DD/MM/YYYY') : '-'}</span>
            <span><b>Formatura:</b> {dadosContrato.dt_formatura ? moment(dadosContrato.dt_formatura).format('DD/MM/YYYY') : '-'}</span>
          </div>

          {/* Lista de etapas */}
          <div style={{ padding: '16px 20px' }}>
            {procedimentos.length === 0 ? (
              <p style={{ color: '#94a3b8', textAlign: 'center' }}>Nenhuma etapa cadastrada.</p>
            ) : (
              procedimentos.map(function(proc, i) {
                const info = {
                  cor: '#94a3b8', bg: '#f1f5f9', label: 'Aguardando', icon: '○'
                };
                const s = (proc.Status || '').toLowerCase();
                if (proc.atrasado)                        { info.cor = '#dc2626'; info.bg = '#fee2e2'; info.label = 'Atrasado';    info.icon = '!'; }
                else if (s === 'concluido')               { info.cor = '#16a34a'; info.bg = '#dcfce7'; info.label = 'Concluído';   info.icon = '✓'; }
                else if (s === 'execução' || s === 'execucao') { info.cor = '#2563eb'; info.bg = '#dbeafe'; info.label = 'Em execução'; info.icon = '▶'; }

                return (
                  <div key={i} style={{
                    display: 'flex', alignItems: 'flex-start', gap: 12,
                    padding: '10px 0',
                    borderBottom: i < procedimentos.length - 1 ? '1px solid #f1f5f9' : 'none',
                  }}>
                    {/* Ícone de status */}
                    <div style={{
                      width: 28, height: 28, borderRadius: '50%',
                      background: info.bg, color: info.cor,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 12, fontWeight: 700, flexShrink: 0,
                    }}>
                      {info.icon}
                    </div>

                    {/* Conteúdo */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                        <span style={{ fontSize: 11, color: '#94a3b8', background: '#f1f5f9', padding: '1px 6px', borderRadius: 8 }}>
                          {proc.nIndex}
                        </span>
                        <span style={{ fontSize: 13, fontWeight: 600, color: proc.atrasado ? '#dc2626' : '#1e293b', flex: 1 }}>
                          {proc.procedimento}
                        </span>
                        <span style={{
                          fontSize: 10, fontWeight: 700, textTransform: 'uppercase',
                          padding: '2px 8px', borderRadius: 20,
                          background: info.bg, color: info.cor,
                        }}>
                          {info.label}
                        </span>
                      </div>
                      <div style={{ display: 'flex', gap: 14, marginTop: 4, fontSize: 11, color: '#64748b', flexWrap: 'wrap' }}>
                        {proc.dtini && <span>{'Início: ' + moment(proc.dtini).format('DD/MM/YYYY')}</span>}
                        {proc.dtfim && <span>{'Prazo: ' + moment(proc.dtfim).format('DD/MM/YYYY')}</span>}
                        {proc.Resp && <span>{'Resp: ' + proc.Resp}</span>}
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      );
    };

    return (
      <section className='content'>
        <div className='row'>
          <div className='col-xs-12'>
            <div className='box'>
              <div className='box-header with-border' style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <h3 className='box-title' style={{ margin: 0 }}>Cronograma</h3>
                {dadosContrato && (
                  <span style={{
                    background: '#f1f5f9', border: '1px solid #e2e8f0',
                    borderRadius: 20, padding: '2px 12px',
                    fontSize: 12, fontWeight: 600, color: '#475569',
                  }}>
                    {dadosContrato.contrato}
                  </span>
                )}
              </div>
              <div className='box-body' style={{ padding: 0 }}>
                {renderCorpo()}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    contrato: state.contrato.especifico,
    carregando: state.contrato.carregando,
  };
};

export default connect(mapStateToProps)(Cronograma);
